import styled from 'styled-components';

const PageSearch = styled.input.attrs(() => ({
  type: 'search',
}))`
  background: ${({ theme }) => theme.baseColors.gray[6]};
  border: 0;
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[3]}
    ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[7]};
  transition: background 200ms ease-in-out;
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  html[data-color-mode='dark'] & {
    background: ${({ theme }) => theme.baseColors.gray[9]};
  }

  &::placeholder {
    color: ${({ theme }) => theme.baseColors.gray[3]};
  }

  &:hover {
    background: ${({ theme }) => theme.baseColors.gray[5]};

    html[data-color-mode='dark'] & {
      background: ${({ theme }) => theme.baseColors.gray[8]};
    }
  }

  &:focus {
    background: ${({ theme }) => theme.baseColors.gray[4]};
    outline: none;

    html[data-color-mode='dark'] & {
      background: ${({ theme }) => theme.baseColors.gray[7]};
    }
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    height: 20px;
    width: 20px;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%23FFFFFFCC'/%3E%3C/svg%3E");

    &:hover {
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z' fill='%23FFFFFFFF'/%3E%3C/svg%3E");
    }
  }
`;

export { PageSearch };
